import { useState } from 'react';
import { useIntl } from 'react-intl';

import { FocusRingVariants, Modal } from '@calm-web/design-system';

import purchaseMessages from '@/components/purchase/messages';
import { useAnalytics } from '@/hooks/analytics';

import HelpModal from '../HelpModal';
import { HelpIcon, Wrapper } from './styles';

export default function HelpButton() {
	const { formatMessage } = useIntl();
	const { logEvent } = useAnalytics();

	const [isModalOpen, setIsModalOpen] = useState(false);

	const openModal = () => {
		setIsModalOpen(true);
		logEvent({
			eventName: 'Subscribe : Purchase : Form : Tool Tip : Clicked',
			eventProps: {
				is_stripe_next: true,
				tool_tip: 'why now',
			},
		});
	};

	const closeModal = () => {
		setIsModalOpen(false);
	};

	return (
		<>
			<Wrapper
				Icon={HelpIcon}
				aria-label={formatMessage(purchaseMessages.cvvHelpModalTitle)}
				onPress={openModal}
				focusRingVariant={FocusRingVariants.Dark}
			/>
			<Modal isOpen={isModalOpen} closeModal={closeModal} canClose aria-label="">
				<HelpModal onCloseClick={closeModal} />
			</Modal>
		</>
	);
}
